import React from 'react';
import PropTypes from 'prop-types';

import { Dialog, DialogContent, DialogTitle } from '@mui/material';

import Button from '../../formElements/Button';

import AuditSelfEmployedCoachManagement from './AuditSelfEmployedCoachManagement';

import modal from '../../../commonStyles/modal.module.css';

const AuditSelfEmployedCoachModal = ({ isOpen, label, onClose }) => {
    return (
        <Dialog
            id="auditModal"
            className="muiDialogWrapper"
            open={isOpen}
            onClose={onClose}
            onClick={(e) => e.stopPropagation()}>
            <div className={modal.modalHeader}>
                <DialogTitle>{label} Change History</DialogTitle>
            </div>
            <DialogContent>
                <>
                    <div className={modal.mainContent}>
                        <AuditSelfEmployedCoachManagement />
                    </div>
                    <div className={modal.actionButtons}>
                        <div className={modal.cancelButton}>
                            <Button id="auditModalButton" onClick={onClose} content="Close" />
                        </div>
                    </div>
                </>
            </DialogContent>
        </Dialog>
    );
};

AuditSelfEmployedCoachModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    label: PropTypes.string,
    onClose: PropTypes.func.isRequired
};

export default AuditSelfEmployedCoachModal;
